import { useBaseCrudService } from 'framework/crud';
import { useKernelApi } from 'infrastructure/api';

const useCommonSkillsService = () => {
  const { search: findByName } = useBaseCrudService({
    listResourceUrl: `/common-skills`,
    singleResourceUrl: `/common-skills/:id`,
    useService: useKernelApi,
  });

  const searchByName = async (query: any) => {
    const data = await findByName({
      pageNumber: 0,
      pageSize: 30,
      filter: {
        name: {
          ct: query,
        },
      },
    });

    return data.result;
  };

  return {
    searchByName,
  };
};

export default useCommonSkillsService;
